export default "__VITE_ASSET__VRAku6fjghkApIISiBWPzg__ 480w, __VITE_ASSET__WPGYjwIlzWVNM1bYhOc83w__ 768w, __VITE_ASSET__8HSUfh7cJHNFxCkInNzNXw__ 1200w";